import { fromJS } from 'immutable';
import { handleError } from 'helpers/app/ErrorHandler.js';
import { getText } from 'helpers/app/getText';

export const actions = {
  ATTEMPT_ADD_PRODUCT_TO_CART: 'ATTEMPT_ADD_PRODUCT_TO_CART',
  ATTEMPT_ADD_PRODUCT_TO_CART_SUCCEED: 'ATTEMPT_ADD_PRODUCT_TO_CART_SUCCEED',
  ATTEMPT_ADD_PRODUCT_TO_CART_FAILED: 'ATTEMPT_ADD_PRODUCT_TO_CART_FAILED',
  ATTEMPT_CHECK_SWISH_PAYMENT_STATUS: 'ATTEMPT_CHECK_SWISH_PAYMENT_STATUS',
  ATTEMPT_CHECK_SWISH_PAYMENT_STATUS_SUCCEED: 'ATTEMPT_CHECK_SWISH_PAYMENT_STATUS_SUCCEED',
  ATTEMPT_CHECK_SWISH_PAYMENT_STATUS_FAILED: 'ATTEMPT_CHECK_SWISH_PAYMENT_STATUS_FAILED',
  ATTEMPT_PAY_POS_SESSION: 'ATTEMPT_PAY_POS_SESSION',
  ATTEMPT_PAY_POS_SESSION_SUCCEED: 'ATTEMPT_PAY_POS_SESSION_SUCCEED',
  ATTEMPT_PAY_POS_SESSION_FAILED: 'ATTEMPT_PAY_POS_SESSION_FAILED',
  ATTEMPT_GET_QUICKSHOP: 'ATTEMPT_GET_QUICKSHOP',
  ATTEMPT_GET_QUICKSHOP_SUCCEED: 'ATTEMPT_GET_QUICKSHOP_SUCCEED',
  ATTEMPT_GET_QUICKSHOP_FAILED: 'ATTEMPT_GET_QUICKSHOP_FAILED',
  ATTEMPT_GET_BOOKING_CART: 'ATTEMPT_GET_BOOKING_CART',
  ATTEMPT_GET_BOOKING_CART_SUCCEED: 'ATTEMPT_GET_BOOKING_CART_SUCCEED',
  ATTEMPT_GET_BOOKING_CART_FAILED: 'ATTEMPT_GET_BOOKING_CART_FAILED',
  ATTEMPT_ONLY_START_POS_SESSION: 'ATTEMPT_ONLY_START_POS_SESSION',
  ATTEMPT_START_POS_SESSION: 'ATTEMPT_START_POS_SESSION',
  ATTEMPT_START_POS_SESSION_SUCCEED: 'ATTEMPT_START_POS_SESSION_SUCCEED',
  ATTEMPT_START_POS_SESSION_FAILED: 'ATTEMPT_START_POS_SESSION_FAILED',
  ATTEMPT_STOP_POS_SESSION: 'ATTEMPT_POS_SESSION',
  ATTEMPT_STOP_POS_SESSION_SUCCEED: 'ATTEMPT_STOP_POS_SESSION_SUCCEED',
  ATTEMPT_STOP_POS_SESSION_FAILED: 'ATTEMPT_STOP_POS_SESSION_FAILED',
  ATTEMPT_GET_POS_SESSION: 'ATTEMPT_GET_POS_SESSION',
  ATTEMPT_GET_POS_SESSION_SUCCEED: 'ATTEMPT_GET_POS_SESSION_SUCCEED',
  ATTEMPT_GET_POS_SESSION_FAILED: 'ATTEMPT_GET_POS_SESSION_FAILED',
  ATTEMPT_LINK_QUICKSHOP: 'ATTEMPT_LINK_QUICKSHOP',
  ATTEMPT_LINK_QUICKSHOP_SUCCEED: 'ATTEMPT_LINK_QUICKSHOP_SUCCEED',
  ATTEMPT_LINK_QUICKSHOP_FAILED: 'ATTEMPT_LINK_QUICKSHOP_FAILED',
  ATTEMPT_RESET_NOTIFICATION_STATE: 'ATTEMPT_RESET_NOTIFICATION_STATE',
  ATTEMPT_GET_TOP_MEASUREMENT_DATA: 'ATTEMPT_GET_TOP_MEASUREMENT_DATA',
  ATTEMPT_GET_TOP_MEASUREMENT_DATA_SUCCEED: 'ATTEMPT_GET_TOP_MEASUREMENT_DATA_SUCCEED',
  ATTEMPT_GET_TOP_MEASUREMENT_DATA_FAILED: 'ATTEMPT_GET_TOP_MEASUREMENT_DATA_FAILED',
  ATTEMPT_GET_RECEIPT_DATA: 'ATTEMPT_GET_RECEIPT_DATA',
  ATTEMPT_GET_RECEIPT_DATA_SUCCEED: 'ATTEMPT_GET_RECEIPT_DATA_SUCCEED',
  ATTEMPT_GET_RECEIPT_DATA_FAILED: 'ATTEMPT_GET_RECEIPT_DATA_FAILED',
  ATTEMPT_GET_MEASUREMENT_DATA: 'ATTEMPT_GET_MEASUREMENT_DATA',
  ATTEMPT_GET_MEASUREMENT_DATA_SUCCEED: 'ATTEMPT_GET_MEASUREMENT_DATA_SUCCEED',
  ATTEMPT_GET_MEASUREMENT_DATA_FAILED: 'ATTEMPT_GET_MEASUREMENT_DATA_FAILED',
  ATTEMPT_START_RENTAL: 'ATTEMPT_START_RENTAL',
  ATTEMPT_START_RENTAL_SUCCEED: 'ATTEMPT_START_RENTAL_SUCCEED',
  ATTEMPT_START_RENTAL_FAILED: 'ATTEMPT_START_RENTAL_FAILED',
  ATTEMPT_END_RENTAL: 'ATTEMPT_END_RENTAL',
  ATTEMPT_END_RENTAL_SUCCEED: 'ATTEMPT_END_RENTAL_SUCCEED',
  ATTEMPT_END_RENTAL_FAILED: 'ATTEMPT_END_RENTAL_FAILED',
  ATTEMPT_UPDATE_QUICKSHOP: 'ATTEMPT_UPDATE_QUICKSHOP',
  ATTEMPT_UPDATE_QUICKSHOP_SUCCEED: 'ATTEMPT_UPDATE_QUICKSHOP_SUCCEED',
  ATTEMPT_UPDATE_QUICKSHOP_FAILED: 'ATTEMPT_UPDATE_QUICKSHOP_FAILED',
};

const defaultState = fromJS({
  error: {},
  message: '',
  cart: {},
  quickshopWeb: {},
  swishPaymentStatus: '',
  isProductAddedToCart: false,
  isPOSSessionStarted: false,
  isPOSSessionStopped: false,
  isPayPOSSessionSucceed: false,
  isQuickshopLinked: false,
  isQuickshopLinkFailed: false,
  posSession: {},
  posSessionID: '',
  measurementData: [],
  topMeasurementData: [],
  isQuickshopRentalStarted: false,
  isQuickshopRentalEnded: false,
  isQuickshopUpdated: false,
  quickShopRentalCustomerId: '',
  isLoading: false,
});

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case actions.ATTEMPT_RESET_NOTIFICATION_STATE:
      return state.set('message', '').set('error', {})
.set(payload.data, false);

    case actions.ATTEMPT_START_RENTAL:
      return state.set('message', '').set('error', {})
.set('isQuickshopRentalStarted', false);

    case actions.ATTEMPT_UPDATE_QUICKSHOP:
      return state.set('message', '').set('error', {})
.set('isQuickshopUpdated', false);

    case actions.ATTEMPT_UPDATE_QUICKSHOP_SUCCEED:
      return state.set('message', '').set('error', {})
.set('isQuickshopUpdated', true);

    case actions.ATTEMPT_UPDATE_QUICKSHOP_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_UPDATE_QUICKSHOP_FAILED_MSG')));

    case actions.ATTEMPT_START_RENTAL_SUCCEED:
      return state.set('message', '').set('error', {})
.set('isQuickshopRentalStarted', true)
.set('quickShopRentalCustomerId', payload.data.customerID);

    case actions.ATTEMPT_START_RENTAL_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_START_RENTAL_FAILED_MSG')));

    case actions.ATTEMPT_END_RENTAL:
      return state.set('message', '').set('error', {})
.set('isQuickshopRentalEnded', false);

    case actions.ATTEMPT_END_RENTAL_SUCCEED:
      return state.set('message', '').set('error', {})
.set('isQuickshopRentalEnded', true);

    case actions.ATTEMPT_END_RENTAL_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_END_RENTAL_FAILED_MSG')));

    case actions.ATTEMPT_LINK_QUICKSHOP:
      return state.set('message', '').set('error', {})
.set('isQuickshopLinked', false)
.set('isQuickshopLinkFailed', false);

    case actions.ATTEMPT_LINK_QUICKSHOP_SUCCEED:
      return state.set('message', '').set('error', {})
.set('isQuickshopLinked', true)
.set('isQuickshopLinkFailed', false);

    case actions.ATTEMPT_LINK_QUICKSHOP_FAILED:
      return state
        .set('error', payload.data)
        .set('isQuickshopLinkFailed', true)
        .set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_LINK_QUICKSHOP_FAILED_MSG'), ''));

    case actions.ATTEMPT_GET_MEASUREMENT_DATA:
      return state.set('message', '').set('error', {})
.set('measurementData', []);

    case actions.ATTEMPT_GET_MEASUREMENT_DATA_SUCCEED:
      return state.set('message', '').set('error', {})
.set('measurementData', payload.data);

    case actions.ATTEMPT_GET_MEASUREMENT_DATA_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_GET_MEASUREMENT_DATA_FAILED_MSG'), ''));

    case actions.ATTEMPT_GET_TOP_MEASUREMENT_DATA:
      return state.set('message', '').set('error', {})
.set('topMeasurementData', []);

    case actions.ATTEMPT_GET_TOP_MEASUREMENT_DATA_SUCCEED:
      return state.set('message', '').set('error', {})
.set('topMeasurementData', payload.data);

    case actions.ATTEMPT_GET_TOP_MEASUREMENT_DATA_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_GET_TOP_MEASUREMENT_DATA_FAILED_MSG'), ''));

    case actions.ATTEMPT_GET_POS_SESSION:
      return state.set('message', '').set('error', {})
.set('posSession', {});

    case actions.ATTEMPT_GET_POS_SESSION_SUCCEED:
      return state.set('error', {}).set('message', '')
.set('posSession', payload.data);

    case actions.ATTEMPT_GET_POS_SESSION_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_GET_POS_SESSION_FAILED_MSG'), ''));

    case actions.ATTEMPT_ONLY_START_POS_SESSION:
      return state.set('message', '').set('error', {})
.set('isPOSSessionStarted', true);

    case actions.ATTEMPT_START_POS_SESSION:
      return state.set('message', '').set('error', {})
.set('isPOSSessionStarted', false);

    case actions.ATTEMPT_START_POS_SESSION_SUCCEED:
      return state.set('message', '').set('error', {})
.set('isPOSSessionStarted', true)
.set('posSessionID', payload.data.posSessionID);

    case actions.ATTEMPT_START_POS_SESSION_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_START_POS_SESSION_FAILED_MSG'), ''));

    case actions.ATTEMPT_STOP_POS_SESSION:
      return state.set('error', {}).set('message', '')
.set('isPOSSessionStopped', false);

    case actions.ATTEMPT_STOP_POS_SESSION_SUCCEED:
      return state.set('error', {}).set('message', '')
.set('isPOSSessionStopped', true);

    case actions.ATTEMPT_STOP_POS_SESSION_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_STOP_POS_SESSION_FAILED_MSG'), ''));

    case actions.ATTEMPT_GET_BOOKING_CART:
      return state.set('message', '').set('error', {})
.set('cart', {});

    case actions.ATTEMPT_GET_BOOKING_CART_SUCCEED:
      return state.set('message', '').set('error', {})
.set('cart', payload.data);

    case actions.ATTEMPT_GET_BOOKING_CART_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_GET_BOOKING_CART_FAILED_MSG'), ''));

    case actions.ATTEMPT_ADD_PRODUCT_TO_CART:
      return state.set('message', '').set('error', {})
.set('isProductAddedToCart', false);

    case actions.ATTEMPT_ADD_PRODUCT_TO_CART_SUCCEED:
      return state.set('message', '').set('error', {})
.set('isProductAddedToCart', true);

    case actions.ATTEMPT_ADD_PRODUCT_TO_CART_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_ADD_PRODUCT_TO_CART_FAILED_MSG'), ''));

    case actions.ATTEMPT_CHECK_SWISH_PAYMENT_STATUS:
      return state.set('error', {}).set('message', '')
.set('swishPaymentStatus', '');

    case actions.ATTEMPT_CHECK_SWISH_PAYMENT_STATUS_SUCCEED:
      return state.set('error', {}).set('message', '')
.set('swishPaymentStatus', payload.data.paymentStatus);

    case actions.ATTEMPT_CHECK_SWISH_PAYMENT_STATUS_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_CHECK_SWISH_PAYMENT_STATUS_FAILED_MSG'), ''));

    case actions.ATTEMPT_PAY_POS_SESSION:
      localStorage.setItem('secret', '');
      localStorage.setItem('stripeAccountID', '');

      return state.set('error', {}).set('message', '')
.set('isPayPOSSessionSucceed', false);

    case actions.ATTEMPT_PAY_POS_SESSION_SUCCEED:
      if (payload.data.pspClientSecret) {
        localStorage.setItem('secret', payload.data.pspClientSecret);
        localStorage.setItem('stripeAccountID', payload.data.stripeAccountID);
      }

      return state.set('error', {}).set('message', '')
.set('isPayPOSSessionSucceed', true);

    case actions.ATTEMPT_PAY_POS_SESSION_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_PAY_POS_SESSION_FAILED_MSG'), ''));

    case actions.ATTEMPT_GET_QUICKSHOP:
      return state.set('error', {}).set('message', '')
.set('isLoading', true)
.set('quickshopWeb', {});

    case actions.ATTEMPT_GET_QUICKSHOP_SUCCEED:
      return state.set('error', {}).set('message', '')
.set('isLoading', false)
.set('quickshopWeb', payload.data);

    case actions.ATTEMPT_GET_QUICKSHOP_FAILED:
      return state
        .set('error', payload.data)
        .set('isLoading', false)
        .set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_GET_QUICKSHOP_FAILED_MSG'), ''));

    case actions.ATTEMPT_GET_RECEIPT_DATA:
      return state.set('error', {}).set('message', '')
.set('receiptData', {});

    case actions.ATTEMPT_GET_RECEIPT_DATA_SUCCEED:
      return state.set('error', {}).set('message', '')
.set('receiptData', payload.data);

    case actions.ATTEMPT_GET_RECEIPT_DATA_FAILED:
      return state.set('error', payload.data).set('message', handleError(payload.data.code, getText('notifications:ATTEMPT_GET_RECEIPT_DATA_FAILED_MSG'), ''));

    default:
      return state;
  }
};
